import { Fragment, useMemo } from 'react'
import { Link } from 'react-router-dom'

const PLAYER_LINK_REGEX = /\[player:([^:]+):([^\]]+)\]/g

type Segment =
	| { type: 'text'; value: string }
	| { type: 'playerLink'; username: string; playerId: string }

function parseTextWithPlayerLinks(text: string): Segment[] {
	const segments: Segment[] = []
	let lastIndex = 0

	for (const match of text.matchAll(PLAYER_LINK_REGEX)) {
		const matchIndex = match.index!
		if (matchIndex > lastIndex) {
			segments.push({ type: 'text', value: text.slice(lastIndex, matchIndex) })
		}
		segments.push({
			type: 'playerLink',
			username: match[1],
			playerId: match[2],
		})
		lastIndex = matchIndex + match[0].length
	}

	if (lastIndex < text.length) {
		segments.push({ type: 'text', value: text.slice(lastIndex) })
	}

	return segments
}

interface MessageTextRendererProps {
	text?: string
}

export function MessageTextRenderer({ text }: MessageTextRendererProps) {
	const segments = useMemo(
		() => (text ? parseTextWithPlayerLinks(text) : []),
		[text],
	)

	if (!text) return null

	if (segments.length === 1 && segments[0].type === 'text') {
		return <>{text}</>
	}

	return (
		<>
			{segments.map((seg, i) => (
				<Fragment key={i}>
					{seg.type === 'text' ? (
						seg.value
					) : (
						<Link
							to={`/operator/get-player-list/player-detail/${seg.playerId}`}
							className="font-medium text-blue-600 underline hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
							onClick={(e) => e.stopPropagation()}
						>
							{seg.username}
						</Link>
					)}
				</Fragment>
			))}
		</>
	)
}
